export default {
	setListOfDeals(state, payload) {
		state.listOfDeals = payload;
	},
	setStatus(state, payload) {
		state.status = payload;
	},
	setPage(state, payload) {
		state.page = payload;
	},
	setPages(state, payload) {
		state.pages = payload;
	},
};
